import React from 'react';
import { Link } from 'react-router-dom';
import NoticiaCardMedia from './NoticiaCardMedia';
import { noticiaTieneMediaInteractiva } from '../utils/noticiaMedia';

/**
 * Tarjeta de noticia en inicio/listado.
 * - Imagen simple: toda la tarjeta abre la noticia.
 * - Video o carrusel: solo título/texto abren la noticia; la media es interactiva.
 */
const NoticiaCard = ({ noticia, fallbackImageSrc, className = '', children }) => {
  const to = `/noticias/${noticia.id}`;
  const ariaLabel = `Leer noticia: ${noticia.titulo}`;
  const interactive = noticiaTieneMediaInteractiva(noticia);

  const media = (
    <NoticiaCardMedia
      noticia={noticia}
      fallbackImageSrc={fallbackImageSrc}
      wrapperClassName="noticia-card-image"
      variant="card"
    />
  );

  if (interactive) {
    return (
      <article
        className={`noticia-card noticia-card--media-interactiva ${className}`.trim()}
      >
        <div className="noticia-card-media-zone">
          {media}
        </div>
        <Link
          to={to}
          className="noticia-card-content-link"
          aria-label={ariaLabel}
        >
          {children}
        </Link>
      </article>
    );
  }

  return (
    <Link
      to={to}
      className={`noticia-card noticia-card-link ${className}`.trim()}
      aria-label={ariaLabel}
    >
      {media}
      {children}
    </Link>
  );
};

export default NoticiaCard;
